// src/domains/revenue/pages/transfer-page.jsx
import React, { useEffect, useState } from "react";
import { getJson, postJson } from "../../../utils/api";
import UploadProof from "../../../components/UploadProof";

export function RevenueTransferPage({ match, history }) {
  const id = match?.params?.id;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [proofUrl, setProofUrl] = useState("");

  useEffect(() => {
    async function run() {
      try {
        const res = await getJson(`/api/v3/revenues/${id}`);
        setData(res);
      } catch (e) {
        setError(e?.message || "Load failed");
      } finally {
        setLoading(false);
      }
    }
    run();
  }, [id]);

  async function submitProof() {
    try {
      await postJson(`/api/v3/revenues/${id}/finance/submit-proof`, { proof_url: proofUrl });
      alert("Proof submitted. Counterparty will be notified automatically.");
      history?.push("/finance");
    } catch (e) {
      alert(e?.message || "Submit failed");
    }
  }

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!data) return <div>No data</div>;

  return (
    <div className="container py-3">
      <h3>Revenue Transfer</h3>
      <div style={{ marginBottom: 16 }}>
        <div><strong>SKU:</strong> {data.sku}</div>
        <div><strong>Counterparty:</strong> {data.counterparty_name}</div>
        <div><strong>Bank Account:</strong> {data.bank_account_masked}</div>
        <div><strong>Buying Price:</strong> {data.buying_price}</div>
      </div>

      <UploadProof onUploaded={setProofUrl} label="Upload Proof of Payment" />
      {proofUrl && (
        <div style={{ marginTop: 8, fontSize: 12 }}>
          Uploaded to: <a href={proofUrl} target="_blank" rel="noreferrer">{proofUrl}</a>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <button className="btn btn-success" disabled={!proofUrl} onClick={submitProof}>
          Submit & Notify
        </button>
      </div>
    </div>
  );
}
